var _defs, _line, _rect, _polyline, _rect2, _line2, _rect3, _rect4, _line3, _rect5, _polyline2, _rect6, _polyline3, _polyline4, _path, _line4, _line5, _polyline5, _rect7, _line6, _rect8, _polyline6, _line7, _line8, _line9, _path2, _path3, _line10, _line11, _path4, _polyline7, _line12, _line13, _line14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaoloMereghetti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "v1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 4988.785 757.221",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#ffffff;stroke-miterlimit:10;stroke-width:4px;}"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 4054.243,
    y1: 757.189,
    x2: 4054.243,
    y2: 345.151
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 441.327,
    y: 376.883,
    width: 420,
    height: 32.972
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "439.188 343.91 861.327 343.91 861.327 376.883"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2,
    y: 343.91,
    width: 420,
    height: 65.945
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 2,
    y1: 755.949,
    x2: 2,
    y2: 343.91
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 878.515,
    y: 343.91,
    width: 420,
    height: 65.945
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1332.891,
    y: 343.91,
    width: 420,
    height: 65.945
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1315.703,
    y1: 412.039,
    x2: 1315.703
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2470.437,
    y: 1248.908,
    width: 420,
    height: 32.972,
    transform: "translate(5208.759 1627.34) rotate(180)"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "2740.46 411.404 2318.322 411.404 2318.322 378.432"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3346.952,
    y: 1247.958,
    width: 420,
    height: 32.972,
    transform: "translate(6961.789 1625.439) rotate(180)"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "3616.975 410.454 3194.837 410.454 3194.837 377.481"
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "2301.134 412.315 2301.134 344.548 1881.134 344.548"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2251.269,1322.259",
    transform: "translate(-152.115 -903.449)"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1881.134,
    y1: 342.563,
    x2: 1881.134,
    y2: 412.315
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 2091.134,
    y1: 342.605,
    x2: 2091.134,
    y2: 412.357
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "2757.649 412.315 2757.649 344.548 3177.649 344.548"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3634.243,
    y: 345.613,
    width: 420,
    height: 65.945
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 4054.243,
    y1: 755.221,
    x2: 3634.163,
    y2: 755.221
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4660.893,
    y: 1249.062,
    width: 420,
    height: 32.972,
    transform: "translate(9589.67 1627.648) rotate(180)"
  })), _polyline6 || (_polyline6 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "4930.916 411.558 4508.777 411.558 4508.777 378.586"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 4948.206,
    y1: 413.525,
    x2: 4948.206,
    y2: 1.486
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 4967.508,
    y1: 413.525,
    x2: 4967.508,
    y2: 1.486
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 4962.837,
    y1: 71.476,
    x2: 4948.206,
    y2: 71.476
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5101.843,968.988",
    transform: "translate(-152.115 -903.449)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5151.394,967.879",
    transform: "translate(-152.115 -903.449)"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 4986.785,
    y1: 413.525,
    x2: 4986.785,
    y2: 343.631
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 4986.785,
    y1: 23.292,
    x2: 4986.785,
    y2: 1.486
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4441.645,1322.685",
    transform: "translate(-152.115 -903.449)"
  })), _polyline7 || (_polyline7 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "4491.51 413.201 4491.51 345.434 4071.51 345.434"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 4071.51,
    y1: 1.901,
    x2: 4071.51,
    y2: 413.201
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 4982.14,
    y1: 71.476,
    x2: 4967.508,
    y2: 71.476
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1863.946,
    y1: 409.855,
    x2: 1770.079,
    y2: 409.855
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaoloMereghetti);
export default __webpack_public_path__ + "static/media/paolo_mereghetti.462d33df17d093fe02082d1a6b425121.svg";
export { ForwardRef as ReactComponent };